module.exports = __webpack_public_path__ + "static/media/24UHCHR21.03c436f6.jpg";